export const enum MouseButton {
  PRIMARY = 0,
  MIDDLE = 1,
  SECONDARY = 2,
  BACK = 3,
  FORWARD = 4,
}
